export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-thumbnail-v1-960-13e6149967771a7239001e3ac1871b4f.png";